import {useGetData} from '../../src/apiservice/apiCall'


export function useCorporateValues(){
	return useGetData('/api/WebApi/GetReport')
}
